export default __webpack_public_path__ + "static/media/gm-sbo-girl.2ebd0000.webp";